const LOAD_DATA_CLIENTS           = 'LOAD_DATA_CLIENTS'
const LOAD_DATA_CLIENTS_SUCCESS   = 'LOAD_DATA_CLIENTS_SUCCESS'
const LOAD_DATA_CLIENTS_FAILED    = 'LOAD_DATA_CLIENTS_FAILED'
const UNMOUNT_DATA_CLIENTS        = 'UNMOUNT_DATA_CLIENTS'

const initialState = {
  loading: true,
  data: null,
  message: null,
  pagination: {
    page: 1,
    total: 0,
    perpage: 10
  }
}

const clientReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_CLIENTS:
      return {
        ...state,
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case LOAD_DATA_CLIENTS_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        pagination: {
          total: action.payload.pagination.total,
          page: action.payload.pagination.page,
          perpage: action.payload.pagination.perpage
        }
      }
    case LOAD_DATA_CLIENTS_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case UNMOUNT_DATA_CLIENTS:
      return { 
        ...state, 
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    default:
      return state
  }
}

export default clientReducer;